module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/regenerator/index.js
// module id = Xxa5
// module chunks = 0 1 2 3 4 5 6 7 8 9 20 21 22 23 24 25 36 40 41 42 43 44 45 46 47 48 49 51 52